import { Box, Button, Grid, Modal, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import FixtureApi from './api/FixtureApi';
import BaseResponse from '../../app/BaseResponse';
import FixtureModel from './models/FixtureModel';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import { contactSelectorSelector } from '../ContactSelector/reducers/ContactSelectorReducer';
import { FixtureSearchSelector } from './reducers/FixtureSearchReducer';
import NumberFormatCustom from '../NumberFormatCustom/NumberFormatCustom';
import { FixtureEvaluationInputSelector, setEvaBroker, setEvaManager, setEvaSupport, setFixtureEvaluationInput, setShowEvaluationInputPanel } from './reducers/FixtureEvaluationInputReducer';
import FixtureEvaluationInputModel from './models/FixtureEvaluationInputModel';
import { setInitEvaComplex } from './reducers/FixtureInputReducer';
import { SupportSheetStatus } from '../SupportSheet/models/SupportSheetModel';

const FixtureEditEvaluation: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const fixtureEvaluationInputViewData = useSelector(FixtureEvaluationInputSelector);
    const contactSelectorData = useSelector(contactSelectorSelector);
    let fixtureData = useSelector(FixtureSearchSelector);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "60%",
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        maxHeight: "calc(100% - 100px)",
        overflow: "auto"
    };

    useEffect(() => {
        if (fixtureEvaluationInputViewData.selectedFixtureId.length > 0) {
            selectFixtureById(fixtureEvaluationInputViewData.selectedFixtureId);
        }
    }, [fixtureEvaluationInputViewData.selectedFixtureId])

    const selectFixtureById = (id: string) => {
        dispatch(showLoading(true));
        FixtureApi.GetById({
            id: id
        }).then((response: BaseResponse<FixtureModel>) => {
            if (response.success) {
                let fixtureInput = Utility.CloneObject(response.data) as FixtureEvaluationInputModel;

                dispatch(setFixtureEvaluationInput(fixtureInput));

                dispatch(showLoading(false));

            } else {
                Utility.Alert.Error(response.message);
                dispatch(showLoading(false));
            }
        }).catch((error) => {
            Utility.Alert.Error(error);
            dispatch(showLoading(false));
        })
    };

    return (
        <>
            <Modal
                open={fixtureEvaluationInputViewData.showEvaluationInputPanel}
                onClose={() => {
                    dispatch(setShowEvaluationInputPanel(false));
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <h1>Update Evaluation</h1>
                    <br />
                    <TextField
                        fullWidth
                        className="cargo-input-component"
                        label="Eva Support"
                        disabled={fixtureEvaluationInputViewData.input.status !== SupportSheetStatus.CloseFile}
                        value={fixtureEvaluationInputViewData.input.evaSupport ? fixtureEvaluationInputViewData.input.evaSupport : ""}
                        onChange={(event) => {
                            let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                            dispatch(setEvaSupport(value));
                        }}
                    >
                    </TextField>
                    <TextField
                        fullWidth
                        className="cargo-input-component"
                        label="Eva Manager"
                        disabled={fixtureEvaluationInputViewData.input.status !== SupportSheetStatus.CloseFile || fixtureEvaluationInputViewData.input.evaSupport == null}
                        value={fixtureEvaluationInputViewData.input.evaManager ? fixtureEvaluationInputViewData.input.evaManager : ""}
                        onChange={(event) => {
                            let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                            dispatch(setEvaManager(value));
                        }}
                    >
                    </TextField>
                    <TextField
                        fullWidth
                        className="cargo-input-component"
                        label="Eva Broker"
                        disabled={fixtureEvaluationInputViewData.input.status !== SupportSheetStatus.CloseFile || fixtureEvaluationInputViewData.input.evaSupport == null || fixtureEvaluationInputViewData.input.evaSupport == null}
                        value={fixtureEvaluationInputViewData.input.evaBroker ? fixtureEvaluationInputViewData.input.evaBroker : ""}
                        onChange={(event) => {
                            let value = event.target.value.length == 0 ? 0 : parseFloat(event.target.value);
                            dispatch(setEvaBroker(value));
                        }}
                    >
                    </TextField>
                    <Grid container>
                        <Button
                            variant="outlined"
                        >Save</Button>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
};

export default FixtureEditEvaluation;